import { useMemo } from 'react';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import isEmpty from 'lodash/isEmpty';
import { eachHierarchy } from '@Hooks/LibraryInitialization/MoreUnderscore';
import UserDatabases from '@Services/UserDatabases';
import { getCurrentDbName } from './SearchProgressModalActions';

const getAdvancedQueryletDatabases = (queryFactItem) => {
  const advancedQueryletDatabases = [];

  eachHierarchy(
    queryFactItem,
    (fact) => {
      if (fact.id === 'ADVANCED.QL') {
        const databaseId = get(fact, 'advancedItems[0].databaseId');
        advancedQueryletDatabases.push(databaseId);
      }
    },
    null,
    { children: 'facts' }
  );

  return uniq(advancedQueryletDatabases);
};

export default function useSearchedDatabase({ queries, priorityWatcher, queryFactItem }) {
  const advancedQueryletDatabases = useMemo(() => getAdvancedQueryletDatabases(queryFactItem), [queryFactItem]);

  return useMemo(() => {
    let singleDatabase;
    let currentDbName;

    if (!isEmpty(advancedQueryletDatabases)) {
      // Advanced querylet is present
      singleDatabase = advancedQueryletDatabases.length === 1 && !!advancedQueryletDatabases[0];
      currentDbName = UserDatabases.getDbName(advancedQueryletDatabases[0]);
    } else {
      // Main use case, without advanced querylet
      singleDatabase = queries && Object.keys(queries).length === 1;
      currentDbName = priorityWatcher ? getCurrentDbName(priorityWatcher) : '';
    }

    return {
      singleDatabase,
      currentDbName,
    };
  }, [queries, priorityWatcher, advancedQueryletDatabases]);
}
